import axios from "axios";

const reportsApi = axios.create({
    baseURL: process.env.REACT_APP_REPORTS_API_URL,
});

reportsApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("gcomToken");
    config.headers["api-key"] = process.env.REACT_APP_REPORTS_API_KEY;
    config.headers["Authorization"] = token ? (token.startsWith("Bearer") ? token : `Bearer ${token}`) : "";
    return config;
});

reportsApi.interceptors.response.use(
    (response) => {
        const newToken = response.headers['authorization'] || response.headers['set-authorization'] || response.headers['token'];
        if (newToken) {
            localStorage.setItem("gcomToken", newToken);
        }
        return response;
    },
    async (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("gcomToken");
        }
        return Promise.reject(error);
    }
);

export default reportsApi;